import React from 'react';
import './css/loading.css';

export default function(){
  return(
    <div id="wrapper">
      <title>MyRate</title>
      <meta name="viewport" content="width=480" />
      <div id="" className="wrapper-loading wrapper-lpThanks">
        <div className="webWrap">
          <div className="wrapCover">
          <div className="block-loading">
          <div className="loader"></div>
          <img className="loading-logo" src="/img/common/icon_allwhite.png" alt="loading" />
          </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export const IsLoading = () => {
  return (
    <div className="wrapCover">
      <div className="block-loading">
        <div className="loader blue"></div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/loading.js